import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import pluralize from 'rebook/apps/utils/text/pluralize';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';

import styles from './style.scss';


const RightholdersList = ({ rightholders }) => {
  return (
    <ul className={styles.seriesList}>
      {rightholders.map((rightholder, key) => {
        return rightholder && (
          <li className={styles.seriesItem} key={rightholder && rightholder.id ? rightholder.id : key}>
            <Link to={{
              pathname: rightholder.absolute_url,
              state: { rightholder } }}>
              <div className="billetContainer">
                <div className={styles.series}>
                  <div className={styles.seriesInfo}>
                    <big>
                      <b>
                        <MultilineEllipsisText maxLinesCount="2">
                          {rightholder.name}
                        </MultilineEllipsisText>
                      </b>
                    </big>
                    <span className={styles.seriesBookCount}>
                      {`${rightholder.active_book_count}`}&nbsp;
                      {`${pluralize(rightholder.active_book_count, 'книга', 'книги', 'книг')}`}
                    </span>
                  </div>
                  <div className="shortArrow" />
                </div>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

RightholdersList.propTypes = {
  rightholders: PropTypes.array.isRequired,
};

export default RightholdersList;
